<template>
    <b-container fluid>
        <b-overlay :show="loading"
                   rounded="sm"
                   opacity="0.3"
                   bg-color="#efefef">
            <b-card>
                <template #header>
                    <div class="d-flex justify-content-between">
                        <h5>대상 기업 조회</h5>

                        <b-button @click="createReportHistory">
                            대상 기업 검색
                        </b-button>
                    </div>
                </template>
                <b-row>
                    <b-col cols="12">
                        project_code
                        <div>
                            <b-form-input v-model="globalReportOpt.project_code"
                                          :disabled="loading"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="mt-4">
                <template #header>
                    <div class="d-flex justify-content-between">
                        <h5>결과보고서 옵션 설정</h5>
                        <b-btn :disabled="loading" @click="confirmGenerate">결과보고서 벌크 처리</b-btn>
                    </div>
                </template>

                <b-row class="mb-2">
                    <b-col cols="3">
                        <div class="d-flex">
                            결과보고서 파일명 자동생성
                            <ReportFileNameHelp/>
                        </div>
                        
                        <div>
                            <b-form-checkbox v-model="globalReportOpt.auto_report_name" size="lg" name="check-button"
                                             switch
                                             :disabled="loading"
                            />
                        </div>
                    </b-col>
                    <b-col cols="9">
                        결과보고서 이름
                        <div>
                            <b-form-input v-model="globalReportOpt.report_name"
                                          :disabled="loading || globalReportOpt.auto_report_name"
                            />
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mb-2">
                    <b-col cols="12" lg="3">
                        진행률 ({{ total_processed_count }} / {{ fixed_selected_num }} )
                        <div>
                            <b-progress :value="total_processed_count" :max="fixed_selected_num" height="30px">
                                <b-progress-bar :value="total_processed_count" variant="success">
                                    {{ progressPercent }}%
                                </b-progress-bar>
                            </b-progress>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="3">
                        report mode 일괄 변경
                        <b-form-select v-model="globalReportOpt.report_mode" :options="[
                    { value: null, text: '-- 미선택 --', disabled: true },
                    { value: 'DOC', text: '서면 보고서'  },
                    { value: 'OSIS', text: '실사 보고서'  },
                ]"
                                       :disabled="loading"
                                       @change="changeAllReportMode"
                        />
                    </b-col>
                    <b-col cols="12" lg="3">
                        결과보고서 생성 언어
                        <div>
                            <dropdown-language :lang="globalReportOpt.language" :disabled="loading"
                                               @updateLang="(lang) => updateLang(lang, 'language')"
                            />
                        </div>

                    </b-col>
                    <b-col cols="12" lg="3">
                        결과보고서 배포 언어
                        <div>
                            <dropdown-language :lang="globalReportOpt.submit_lang" :disabled="loading"
                                               @updateLang="(lang) => updateLang(lang, 'submit_lang')"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" lg="2">
                        실제 평가기간 교체
                        <b-form-checkbox v-model="globalReportOpt.is_actual_duration" size="lg" name="check-button"
                                         switch
                                         :disabled="loading"
                        />
                    </b-col>
                    <b-col cols="12" lg="2">
                        재평가 라벨 설정
                        <b-form-checkbox v-model="globalReportOpt.is_reassessment" size="lg" name="check-button" switch
                                         :disabled="loading"
                        />
                    </b-col>
                    <b-col cols="12" lg="2">
                        결과보고서 생성
                        <b-form-checkbox v-model="globalReportOpt.generate_report" size="lg" name="check-button" switch
                                         :disabled="loading"
                        />
                    </b-col>
                    <b-col cols="12" lg="2">
                        결과보고서 확정
                        <b-form-checkbox v-model="globalReportOpt.confirm_report" size="lg" name="check-button" switch
                                         :disabled="loading || !globalReportOpt.generate_report"
                        />
                    </b-col>
                    <b-col cols="12" lg="2">

                        결과보고서 배포
                        <b-form-checkbox v-model="globalReportOpt.release_report" size="lg" name="check-button" switch
                                         :disabled="loading || !globalReportOpt.confirm_report"
                        />
                    </b-col>
                    <b-col cols="12" lg="2">

                        메일 전송 여부
                        <b-form-checkbox v-model="globalReportOpt.is_send_release_mail" size="lg" name="check-button" switch
                                         :disabled="loading || !globalReportOpt.confirm_report"
                        />
                    </b-col>
                </b-row>


            </b-card>
            <b-row class="mb-4 mt-4">
                <b-col cols="12">
                    <h5>일괄 처리 실패 기업</h5>
                    <div>
                        {{ !fail_company_list.length ? '없음' : fail_company_list }}
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                    <div class="virtual-table-wrapper">
                        <div class="header-container">
                            <table class="table b-table table-hover">
                                <thead class="thead-light">
                                <tr>
                                    <th v-for="(field, index) in columns"
                                        :key="field.key"
                                        :style="index === columns.length - 1 ? getLastThStyle(field) : getColumnStyle(field)"
                                        :class="getThClass(field)"
                                    >
                                        <template v-if="field.key === 'selected'">
                                            <b-form-checkbox
                                                v-model="selectedAll"
                                                :indeterminate="indeterminate"
                                                @change="toggleSelectAll"
                                            />

                                        </template>
                                        <template v-else>
                                            {{ $t(field.label) }}
                                        </template>
                                    </th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                        <div v-if="project_history.length === 0" class="empty-container">
                            <b-spinner class="mr-1" small/>
                            <template v-if="!loading">
                                <h6 class="font-italic mb-0">{{ $t('검색된 프로젝트가 없습니다.') }}</h6>
                            </template>
                        </div>
                        <div v-else ref="bodyScrollContainer" class="body-scroll-container">
                            <RecycleScroller
                                v-slot="{ item }"
                                :items="project_history"
                                :item-size="48.6"
                                key-field="company_id"
                            >
                                <table class="body-table">
                                    <tbody>
                                    <tr class="body-row">
                                        <td v-for="field in columns"
                                            :key="field.key"
                                            :style="getColumnStyle(field)"
                                            :class="getTdClass(field)"
                                        >
                                            <template v-if="field.key === 'selected'">
                                                <b-form-checkbox
                                                    :checked="mapSelectedItem[item.company_id].selected"
                                                    @change="toggleSelect(item)"
                                                />
                                            </template>
                                            <template v-else-if="field.key === 'company_id'">
                                                <div class="d-flex">
                                                    <div>
                                                        <b-badge>{{ item.company_id }}</b-badge>
                                                    </div>

                                                    <div v-if="report_generate_target_company_id == item.company_id"
                                                         class="ml-2 d-flex align-items-center">
                                                        <b-spinner class="mr-1" variant="warning" small/>
                                                        <div>처리중</div>
                                                    </div>
                                                    <div v-else-if="done_company_list.includes(item.company_id)"
                                                         class="ml-2">
                                                        <b-badge variant="success" class="mr-1">완료</b-badge>
                                                    </div>
                                                    <div v-else-if="fail_company_list.includes(item.company_id)"
                                                         class="ml-2">
                                                        <b-badge variant="warning" class="mr-1">실패</b-badge>
                                                    </div>
                                                </div>

                                            </template>
                                            <template v-else-if="field.key === 'status_code'">
                                                <b-badge :variant="getProgressColor(item)" class="mr-2">
                                                    {{ getProgressStatus(item) }}
                                                </b-badge>
                                            </template>
                                            <template v-else-if="field.key === 'total_score_timestamp'">
                                                {{ formatDate(item?.total_score_timestamp) || '-' }}
                                            </template>
                                            <template v-else-if="field.key === 'mode'">
                                                <b-form-select v-model="map_assessment_mode[item.company_id]"
                                                               size="sm"
                                                               :options="[
                                                { value: 'DOC', text: '서면 보고서'},
                                                { value: 'OSIS', text: '실사 보고서'},
                                            ]"
                                                />
                                            </template>
                                            <template v-else>
                                                {{ item[field.key] }}
                                            </template>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </RecycleScroller>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <BulkReportContainer v-if="reportData"
                                 ref="reportViewer"
                                 style="opacity: 1"
                                 :report_lang="globalReportOpt.language"
                                 :reportData="reportData"
                                 :pdf_filename="pdf_filename"
                                 :reportMode="reportMode"
                                 :assessmentType="map_assessment_mode[report_generate_target_company_id]"
                                 :is_reassessment="globalReportOpt.is_reassessment"
                                 :set_actual_duration="globalReportOpt.is_actual_duration"
            >

            </BulkReportContainer>
        </b-overlay>

    </b-container>
</template>

<script>
import dropdownLanguage from '@shared/components/utils/dropdown-language.vue';
import BulkReportContainer from '@shared/components/admin/components/report/ReportMamagement/BulkReportContainer.vue';
import ReportCoreMixin from '@shared/mixin/report/report.core.mixin';
import {checkAppEnv, waitTime} from '@shared/utils/common';
import ReportNamingMixin from '@shared/mixin/report/report.naming.mixin';
import AssessmentCommonMixin from '@shared/mixin/assessment.common.mixin';
import {check_is_ksteel, check_is_supply} from '@core/utils/check-app-env';
import {resolveReportTemplate} from '@shared/mixin/report/report-template';
import ReportFileNameHelp from '@shared/components/admin/components/report/ReportMamagement/ReportFileNameHelp.vue';
import {mapActions} from 'vuex';
import dayjs from 'dayjs';

const {supplyFilename} = require('@shared/mixin/report/report-self-assessment.cjs');
const {ksteelReportYear} = require('@shared/mixin/report/report-ksteel-year.cjs');

export default {
    name: 'ReportBulkGenerator',
    mixins: [
        ReportNamingMixin,
        AssessmentCommonMixin,
        {
            methods: {
                addFontVFS: ReportCoreMixin.methods.addFontVFS,
                generatePDFfilename: ReportCoreMixin.methods.generatePDFfilename,
            }
        }
    ],
    props: {},
    components: {
        ReportFileNameHelp,
        BulkReportContainer,
        dropdownLanguage
    },
    data() {
        return {
            project_history: [],
            columns: [
                {key: 'selected', label: '선택', width: 50, hAlign: 'center'},
                {key: 'company_id', label: '회사ID', width: 120, hAlign: 'center'},
                {key: 'company_name', label: '회사명', width: 300, tdClass: 'text-left td-truncate'},
                {key: 'status_code', label: '평가 상태', width: 100, hAlign: 'center'},
                {key: 'service_type', label: '평가 유형', width: 100, hAlign: 'center'},
                {key: 'total_score_timestamp', label: '점수 생성일', width: 150, hAlign: 'center'}, // width가 없으면 남은 공간 차지
                {key: 'mode', label: '생성 보고서 선택', width: 135, hAlign: 'center'},
            ],
            globalReportOpt: {
                project_code: null,
                campaign_id: null,
                report_mode: null,
                language: 'ko',
                submit_lang: 'ko',
                is_reassessment: false,
                is_actual_duration: false,
                generate_report: false,
                confirm_report: false,
                release_report: false,
                report_name: '',
                auto_report_name: true,
                is_send_release_mail: false,
            },
            map_assessment_mode: {},


            loading: false,
            report_generate_target_company_id: null,
            mapSelectedItem: {},
            selectedAll: false,
            selected_num: 0,
            scrollbarWidth: 0,

            // 결과보고서 생성
            reportMode: 'full',
            pdf_filename: null,
            reportData: {
                info: null,
                benchmarks: null,
                parser: null,
                risk: null,
                scoring: null
            },

            // 결과보고서 변수 데이터
            fail_company_list: [],
            done_company_list: [],
            fixed_selected_num: 0,
        };
    },
    computed: {
        indeterminate() {
            return this.selected_num > 0 && this.selected_num < this.project_history.length;
        },
        report_lang() {
            return this.globalReportOpt.language;
        },
        assessment_type() {
            return this.map_assessment_mode[this.report_generate_target_company_id];
        },
        total_processed_count() {
            return this.done_company_list.length + this.fail_company_list.length;
        },
        progressPercent() {
            return this.fixed_selected_num ? ((this.total_processed_count / this.fixed_selected_num) * 100).toFixed(1) : 0;
        }
    },
    watch: {
        loading(value) {
            this.$emit('prevent-close-generator-modal', value);
        },
        'globalReportOpt.generate_report': {
            handler(value) {
                if (!value) this.globalReportOpt.confirm_report = false;
            },
        },
        'globalReportOpt.confirm_report': {
            handler(value) {
                if (!value) {
                    this.globalReportOpt.release_report = false;
                    this.globalReportOpt.is_send_release_mail = false;
                }
            },
        },
        'globalReportOpt.language': {
            handler(value) {
                if (checkAppEnv() === 'hyundai') {
                    if(value === 'ko')
                        this.globalReportOpt.report_name = '2025 현대자동차 사업장 ESG 평가_{기업명}';
                    else
                        this.globalReportOpt.report_name = '2025 Hyundai Motor Business Site ESG Assessment_{기업명}';
                }
                if (checkAppEnv() === 'ksteel') {
                    this.globalReportOpt.report_name = `${ksteelReportYear(this.globalReportOpt.project_code)} 철강 공급망 ESG 실사_서면평가 결과보고서_{기업명}`;
                }
                if (checkAppEnv() === 'supply') {
                    this.globalReportOpt.report_name = this.supplyReportName();
                }
            },
        },
    },
    async created() {
        this.globalReportOpt.project_code = this.$route.query.pc || this.$route.query.project_code;
        if(this.$route.query.cmp){
            this.view_target_report = this.$route.query.cmp;
        }
        
        this.globalReportOpt.report_name = this.report_filename;

        if (checkAppEnv() === 'hyundai') {
            this.globalReportOpt.report_name = '2025 현대자동차 사업장 ESG 평가_{기업명}';
        }
        if (checkAppEnv() === 'ksteel') {
            this.globalReportOpt.report_name = `${ksteelReportYear(this.globalReportOpt.project_code)} 철강 공급망 ESG 실사_서면평가 결과보고서_{기업명}`;
        }
        if (checkAppEnv() === 'supply') {
            this.globalReportOpt.report_name = this.supplyReportName();
        }

        await this.createReportHistory();
    },
    mounted() {
    },
    beforeDestroy() {
        this.$emit('prevent-close-generator-modal', false);
    },
    destroyed() {
    },
    methods: {
        ...mapActions('evaluations', ['fetchEvCode']),
        // supply 기본 보고서 이름 — 자가진단·넥센 서면평가는 프로젝트 코드로 이름을 바꾼다 (report-self-assessment.cjs).
        supplyReportName() {
            return supplyFilename('2026 공급망 ESG 실사_서면평가 결과보고서_{기업명}', this.globalReportOpt.language, this.globalReportOpt.project_code);
        },
        toggleSelectAll() {
            const mapSelectedItem = JSON.parse(JSON.stringify(this.mapSelectedItem));
            this.project_history.forEach(item => {
                if (this.mapSelectedItem[item.company_id].selected !== this.selectedAll) {
                    this.selected_num += this.selectedAll ? 1 : -1;
                }
                mapSelectedItem[item.company_id].selected = this.selectedAll;
            });

            this.mapSelectedItem = mapSelectedItem;
        },
        toggleSelect(item) {
            if (this.mapSelectedItem[item.company_id].selected) {
                this.selected_num--;
            } else {
                this.selected_num++;
            }
            this.mapSelectedItem[item.company_id].selected = !this.mapSelectedItem[item.company_id].selected;
        },
        getLastThStyle(field) {
            const baseStyle = this.getColumnStyle(field);
            if (this.scrollbarWidth > 0 && baseStyle.width) {
                baseStyle.width = `calc(${baseStyle.width} + ${this.scrollbarWidth}px)`;
            } else if (this.scrollbarWidth > 0 && !baseStyle.width) {
                baseStyle.width = `${this.scrollbarWidth}px`;
            }
            return baseStyle;
        },
        getColumnStyle(field) {
            const style = {};
            if (field.width) {
                style.width = typeof field.width === 'number' ? `${field.width}px` : field.width;
            }
            if (field.hAlign) style.textAlign = field.hAlign;
            if (field.vAlign) style.verticalAlign = field.vAlign === 'center' ? 'middle' : field.vAlign;
            return style;
        },
        getThClass(field) {
            return field.thClass || '';
        },
        getTdClass(field) {
            return field.tdClass || '';
        },
        updateLang(lang, key) {
            this.globalReportOpt[key] = lang;
        },
        async createReportHistory() {
            try {
                this.project_history = [];
                this.loading = true;
                console.log('createReportHistory ~ ');
                const _res_project_reports = await this.$axios('/report', {params: {project_code: this.globalReportOpt.project_code}});
                const _res_reports = await this.$axios('/report/history', {
                    params: {
                        project_code: this.globalReportOpt.project_code,
                        with_alt: true
                    }
                });
                console.log(' ~ _res_project_reports => ', _res_project_reports);
                console.log(' ~ _res_reports => ', _res_reports);

                const mapReportHistory = {};
                _res_reports.data.result.forEach(item => {
                    if (item.deleted_at) return;
                    if (item.confirmed) {
                        mapReportHistory[item.company_id] = item;
                    }
                });


                const mapSelectedItem = {};
                const map_assessment_mode = {};
                const _project_reports = _res_project_reports.data.reduce((_reports, _report) => {
                    if (!_reports[_report.company_id]) {
                        const {
                            project_code,
                            campaign_id,
                            company_id,
                            company_name,
                            request_id,
                            requested_e_mail,
                            status_code,
                            service_type,
                            period,
                        } = _report;
                        _reports[_report.company_id] = {
                            project_code, campaign_id,
                            company_id, company_name, request_id, requested_e_mail, status_code, service_type,
                            history_id: mapReportHistory?.[company_id]?.id ?? undefined,
                            period,
                            selected: false,
                        };
                    }

                    map_assessment_mode[_report.company_id] = _report.service_type === '일반' ? 'DOC' : 'OSIS';
                    mapSelectedItem[_report.company_id] = _reports[_report.company_id];


                    return _reports;
                }, {});
                this.project_history = this.sortingCompanies(Object.values(_project_reports), {data: {is_loading: false}});

                this.mapSelectedItem = mapSelectedItem;
                this.map_assessment_mode = map_assessment_mode;


                this.globalReportOpt.campaign_id = this.project_history.length ? this.project_history[0].campaign_id : null;
            } catch (error) {
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                } else {
                    console.log(' ~ error => ', error);
                }
            } finally {
                this.loading = false;
            }
        },
        confirmGenerate() {
            const h = this.$createElement;

            if (this.selected_num === 0) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '결과보고서 벌크 처리',
                    message: h('div', {}, '생성할 기업을 선택해주세요.')
                });
                return;
            }

            // 켜진 단계를 모두 나열한다 (확정/배포는 생성 스위치가 켜져 있어야만 켤 수 있다)
            const { generate_report, confirm_report, release_report, is_send_release_mail } = this.globalReportOpt;
            const messages = [];
            if (generate_report || confirm_report || release_report) {
                const steps = [];
                if (generate_report) steps.push('결과보고서 생성');
                if (confirm_report) steps.push('기존 확정 보고서 확정 취소 후 새 보고서 확정');
                if (release_report) steps.push(`협력사에 배포 (메일 ${is_send_release_mail ? '발송' : '미발송'})`);
                messages.push(h('div', {}, `대상 ${this.selected_num}개사에 아래 단계를 순서대로 진행합니다.`));
                steps.forEach((step, i) => messages.push(h('div', {}, `${i + 1}. ${step}`)));
                messages.push(h('div', {}, `예상 소요시간: 약 ${Math.ceil(this.selected_num * 20 / 60)}~${Math.ceil(this.selected_num * 60 / 60)}분 (기업당 20~60초)`));
                if (release_report) messages.push(h('div', {class: 'text-danger'}, '배포는 되돌릴 수 없으며 시작 후 중단할 수 없습니다.'));
            }


            if (messages.length > 0) {
                this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '결과보고서 벌크 처리',
                    message: h('div', {}, messages),
                })
                    .then((value) => {
                        if (value) {
                            this.generateBulkReport();
                        }
                    });
            } else {
                this.generateBulkReport();
            }
        },
        async generateBulkReport() {
            const full_time_begin = performance.now();
            console.log('generateBulkReport ~ ');
            console.log(' ~ full_time_begin => ', (full_time_begin / 1000));
            // globalReportOpt: {
            //     campaign_id: null,
            //     company_id: null,
            //     report_mode: null,
            //     language: this.$i18n.locale
            // }

            this.loading = true;
            this.fixed_selected_num = this.selected_num;
            this.done_company_list = [];
            this.fail_company_list = [];

            await this.addFontVFS();
            const ev_code = await this.fetchEvCode();

            let stepLv = 0;
            if (this.globalReportOpt.generate_report)
                stepLv += 1;
            if (this.globalReportOpt.confirm_report)
                stepLv += 1;
            if (this.globalReportOpt.release_report)
                stepLv += 1;

            const _buik_companies = Object.values(this.mapSelectedItem).filter(item => item.selected).map(item => item);
            if (_buik_companies.length) {
                for await (const _company of _buik_companies) {
                    const _company_id = _company.company_id;
                    const part_time_begin = performance.now();
                    try {
                        this.report_generate_target_company_id = _company_id;


                        let campaign_id = this.globalReportOpt.campaign_id;
                        if(check_is_ksteel(_company.campaign_id) || check_is_supply(_company.campaign_id)){
                            campaign_id = _company.campaign_id;
                        }
                        // 결과보고서 데이터 호출 및 생성
                        const _res_report_data = await this.$axios('/report/data', {
                            params: {
                                campaign_id: campaign_id,
                                project_code: this.globalReportOpt.project_code,
                                company_id: _company_id
                            }
                        });

                        const _report_data = _res_report_data.data;

                        // 판정 단일 소스 — 백엔드 스냅샷(report_meta) 우선, env 화이트리스트 폴백 (report-template.js)
                        const _resolved_template = resolveReportTemplate({
                            rendererKey: _report_data.report_meta?.report_renderer_key,
                            campaignId: campaign_id,
                        });

                        if (_resolved_template === 'hyundai') {
                            _report_data.scoring.category2_scoring_pd = _report_data.scoring.category2_scoring_pd.reduce((acc, cur) => {
                                if (cur.category2_question_name.includes('1.1')) return acc;
                                if (cur.category2_question_name.includes('2.2')) return acc;
                                acc.push(cur);
                                return acc;
                            }, []);
                            _report_data.scoring.category3_scoring_pd = _report_data.scoring.category3_scoring_pd.reduce((acc, cur) => {
                                if (cur.category2_question_name.includes('1.1')) return acc;
                                if (cur.category2_question_name.includes('2.2')) return acc;
                                acc.push(cur);
                                return acc;
                            }, []);
                        }
                        
                        if(_resolved_template === 'ksteel' || _resolved_template === 'supply'){
                            this.reportData ={
                                ..._res_report_data.data,
                                ev_code_list: ev_code
                            };

                        }
                        else {
                            this.reportData = {
                                info: _report_data.info,
                                benchmarks: _report_data.benchmarks,
                                parser: _report_data.parser_result,
                                risk: _report_data.risk,
                                scoring: _report_data.scoring,
                                template_questions: _report_data.template_questions,
                                report_meta: _report_data.report_meta
                            };
                        }

                       

                        console.log('       ~ 1. this.reportData => ', this.reportData);
                        let report_name = this.globalReportOpt.report_name;
                        if(this.globalReportOpt.auto_report_name){
                            if(report_name === 'TEMPORAL_REPORT_NAME'){
                                report_name = this.generatePDFfilename();
                            }
                            else {
                                report_name = report_name.replace('{기업명}', this.reportData.info.company.company_name || '');
                            }
                        }
                        else {
                            const varList = this.extractCurlyBraceContentsSimple(this.globalReportOpt.report_name);
                            varList.forEach((varName) => {
                                if(varName === '기업명'){
                                    report_name = report_name.replace(`{${varName}}`, this.reportData.info.company.company_name || '');
                                }
                                if(varName === '프로젝트코드'){
                                    report_name = report_name.replace(`{${varName}}`, this.reportData.info.project_code || '');
                                }
                                if(varName === '업체코드'){
                                    report_name = report_name.replace(`{${varName}}`, this.reportData.info.vendor_code || '');
                                }
                                if(varName === '모드'){
                                    report_name = report_name.replace(`{${varName}}`, this.map_assessment_mode[_company_id] || '');
                                }
                                if(varName === '날짜'){
                                    report_name = report_name.replace(`{${varName}}`, dayjs().format('YYYYMMDD-HHmm'));
                                }
                                if(varName === '언어'){
                                    report_name = report_name.replace(`{${varName}}`, this.globalReportOpt.language || '');
                                }
                            });
                        }
                        this.pdf_filename = report_name;
                        


                        // 결과보고서 생성 및 blob 데이터 추출
                        console.log('       ~ 2. generatePDF 메서드 실헹 ');
                        await waitTime(100);
                        const doc = await this.$refs.reportViewer.generatePDF();

                        console.log('       ~ 3. 결과보고서 blob 변환 ');
                        doc.save(`${this.pdf_filename}.pdf`);
                        const pdfBlobData = doc.output('blob', {
                            filename: `${this.pdf_filename}.pdf`
                        });
                        console.log('           ~ pdfBlobData => ', pdfBlobData);

                        // 결과보고서 저장
                        console.log('       ~ 4. 결과보고서 저장 ');
                        const {campaign, company_id, project_code} = this.reportData.info;
                        const pdfFileObj = new File([pdfBlobData], `${this.pdf_filename}.pdf`, {type: 'application/pdf'});

                        const formData = new FormData();
                        formData.append('campaign_id', campaign.id);
                        formData.append('company_id', company_id);
                        formData.append('project_code', project_code);
                        formData.append('report', pdfFileObj);
                        formData.append('en', this.globalReportOpt.language !== 'ko');
                        formData.append('mode', this.map_assessment_mode[_company_id]);


                        let _res_report_release = null;
                        let targetReport = null;
                        if (stepLv >= 1) {
                            _res_report_release = await this.$axios.post('/report/release',
                                formData,
                                {headers: {'Content-Type': 'multipart/form-data'}}
                            );
                            console.log('       ~ 5. _res_report_release.data => ', _res_report_release.data);

                            if (!_res_report_release.data || !_res_report_release.data.report_history_id) {
                                throw new Error('결과보고서 생성에 실패했습니다.');
                            }
                        }

                        if (stepLv >= 2) {
                            targetReport = this.project_history.find(item => Number(item.company_id) === Number(_company_id));
                            console.log('targetReport:::', targetReport);

                            if (this.globalReportOpt.confirm_report) {
                                console.log('       ~ 6. 결과보고서 확정 ');
                                if (targetReport.history_id) {
                                    await this.$axios({
                                        method: 'DELETE',
                                        url: '/report/confirm',
                                        data: {report_id: targetReport.history_id}
                                    });
                                    await waitTime(500);
                                }

                                await this.$axios({
                                    method: 'PUT',
                                    url: '/report/confirm',
                                    data: {report_id: _res_report_release?.data?.report_history_id}
                                });
                                await waitTime(500);
                            }
                        }

                        if (stepLv >= 3) {
                            if (this.globalReportOpt.release_report) {
                                console.log('       ~ 7. 결과보고서 배포 ');

                                await this.$axios.post('/report/submit', {
                                    project_code: project_code,
                                    campaign_id: campaign.id,
                                    company_id: company_id,
                                    history_id: _res_report_release?.data?.report_history_id,
                                    period: targetReport?.period,
                                    lang: this.globalReportOpt.submit_lang,
                                    skip_email: !this.globalReportOpt.is_send_release_mail,
                                });
                            }
                        }


                        this.done_company_list.push(_company_id);
                    } catch (error) {
                        if (error.response) {
                            console.log(' ~ error.response => ', error.response);
                        } else {
                            console.log(' ~ error => ', error);
                            console.error(error);
                        }

                        this.fail_company_list.push(_company_id);
                    } finally {
                        // 마지막 단계 - 결과보고서 데이터 및 이름 변수값 초기화
                        this.reportData = {
                            info: null,
                            benchmarks: null,
                            parser: null,
                            risk: null,
                            scoring: null
                        };
                        this.pdf_filename = null;
                        const part_time_end = performance.now();
                        console.log(`   ~ 처리시간 =>  ${this.formatSpendTime(part_time_end - part_time_begin)}`);

                        if(check_is_ksteel(_company.campaign_id) || check_is_supply(_company.campaign_id)){
                            await waitTime(1000 * 60); // buffer 시간;
                        }
                        else {
                            await waitTime(1000 * 20); // 다른 custom buffer 시간;
                        }
                        this.report_generate_target_company_id = null;
                    }
                }

                // bulk 생성 종료
                this.$emit('update-release');
            }

            this.selected_num = 0;
            const full_time_end = performance.now();
            const total_time = (full_time_end - full_time_begin) / 1000;
            console.log(`종료시간: ${full_time_end / 1000}`);
            console.log(`총 소요시간: ${total_time}`);
            const msg = {
                state: 'success',
                title: '결과보고서 벌크 생성 완료',
            };
            if (this.fail_company_list.length > 0) {
                msg.state = 'warning';
                msg.title = '결과보고서 벌크 생성 실패 - 실패 기업 확인 )';
            }
            this.$showModal({
                type: 'alert',
                state: msg.state,
                title: msg.title,
                message: `소요시간: ${this.formatSpendTime(total_time)}`
            })
                .then(async () => {
                    await this.createReportHistory();
                    this.loading = false;
                    this.selected_num = 0;
                });

        },
        formatSpendTime(ms) {
            const milliseconds = ms % 1000;
            const seconds = Math.floor((ms / 1000) % 60);
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);

            return `${hours ? hours + 'h ' : ''}${minutes ? minutes + 'm ' : ''}${seconds ? seconds + 's ' : ''}${milliseconds.toFixed(3)}ms`;
        },
        changeAllReportMode(mode) {
            this.project_history.forEach(item => {
                this.map_assessment_mode[item.company_id] = mode;
            });
        },
        extractCurlyBraceContentsSimple(text) {
            const matches = text.match(/\{([^}]*)\}/g);
            return matches ? matches.map(match => match.slice(1, -1)) : [];
        }
        
    }
};
</script>

<style scoped>
.empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50vh;
    padding: 2rem;
    color: #6c757d;
    font-style: italic;
}
</style>
